module.exports = __webpack_public_path__ + "static/7-a2bed62ac4ffd8c63f7e1cfaf6ddad5a.png";